import React, { useEffect } from "react";
import "../assets/css/cxda.css";
import "aos/dist/aos.css";
import AOS from "aos";
import hero1 from "../assets/TIG Website Images/Our Businesses/CXDA/CXDAOman.png";
import { FaDatabase, FaClipboardList, FaUsers, FaGlobe, FaChartLine, FaHandshake } from "react-icons/fa";
import { FaInfoCircle, FaHandsHelping, FaMoneyBillWave, FaBitcoin } from "react-icons/fa";
import { FaSearch, FaFileAlt, FaBriefcase } from "react-icons/fa";
import OmanTeam from "./OmanTeam";
import Globalteam from "./Globalteam";
import ContactSection from "./ContactSection";
import SMEAssetsSection from "./SMEAssetsSection";

const Cxda = () => {
     useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);
  return (
    <div>
         {/* Hero Section */}
      <div className="container-fluid p-0" >
        <div
          className="hero-section"
          style={{ backgroundImage: `url(${hero1})` }}
        >
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
              CXDA
              </h1>
            </div>
          </div>
        </div>
      </div>
      {/* vision-section */}
       <section className="vision-section py-5" data-aos="fade-up">
      <div className="container">
        <div className="row align-items-stretch g-0">
          
          {/* Left Red Vision Box */}
          <div className="col-md-4 vision-left d-flex flex-column justify-content-center text-white p-4">
            <h3 className="fw-bold mb-3">CXDA’s Vision</h3>
            <p className="vision-text">
              “Building the infrastructure for a Debt Market attracting global and local 
              liquidity flows for SME finance in the Middle East and Africa.”
            </p>
          </div>

          {/* Right Side Cards */}
          <div className="col-md-8 vision-right p-4">
            <div className="d-flex flex-column gap-3">
              
              <div className="vision-item d-flex align-items-center p-3 rounded">
                <div className="icon-box me-3">
                  <FaInfoCircle />
                </div>
                <p className="mb-0">
                  Standardized information about issuers, assets and inventory records
                </p>
              </div>

              <div className="vision-item d-flex align-items-center p-3 rounded">
                <div className="icon-box me-3">
                  <FaChartLine />
                </div>
                <p className="mb-0">
                  Well defined and transparent rules for investing
                </p>
              </div>

              <div className="vision-item d-flex align-items-center p-3 rounded">
                <div className="icon-box me-3">
                  <FaHandsHelping />
                </div>
                <p className="mb-0">
                  International standards investable assets and collateral
                </p>
              </div>

              <div className="vision-item d-flex align-items-center p-3 rounded">
                <div className="icon-box me-3">
                  <FaMoneyBillWave />
                </div>
                <p className="mb-0">
                  Simplifying cross-border payments and infrastructure
                </p>
              </div>

              <div className="vision-item d-flex align-items-center p-3 rounded">
                <div className="icon-box me-3">
                  <FaBitcoin />
                </div>
                <p className="mb-0">
                  Development of cross-border market and infrastructure
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
      {/*solution-section*/}
     <section className="solution-section py-4" data-aos="fade-up">
      <div className="container">
        <h2 className="text-center fw-bold mb-2 text-danger">The Solution</h2>
        <p className="text-center text-muted mb-5 fs-4">
          Building the information and credit history for the rising digital economy
        </p>

        <div className="row text-center gy-4 gx-4">
          {/* Data & Analytics */}
          <div className="col-md-4">
            <div className="solution-card p-4 h-100">
              <FaDatabase className="icon mb-3" />
              <h5 className="fw-bold mb-3">Data & Analytics</h5>
              <ul className="custom-list1 text-start">
                <li>Standardized information and documentation across MENA markets will be a first</li>
                <li>Building historical track record of successful loan repayments</li>
              </ul>
            </div>
          </div>

          {/* Credit Scoring */}
          <div className="col-md-4">
            <div className="solution-card p-4 h-100">
              <FaClipboardList className="icon mb-3" />
              <h5 className="fw-bold mb-3">Credit Scoring</h5>
              <ul className="custom-list1 text-start">
                <li>Diversified and enhanced risk management and credit scoring</li>
                <li>Competitive low NPL and default rates</li>
              </ul>
            </div>
          </div>

          {/* Friendly Onboarding */}
          <div className="col-md-4">
            <div className="solution-card p-4 h-100">
              <FaUsers className="icon mb-3" />
              <h5 className="fw-bold mb-3">Friendly Onboarding</h5>
              <ul className="custom-list1 text-start">
                <li>Clear rules for onboarding borrowers and lenders</li>
                <li>Automated, fast and easy loan applications</li>
              </ul>
            </div>
          </div>

          {/* Scale & Expansion */}
          <div className="col-md-4">
            <div className="solution-card p-4 h-100">
              <FaGlobe className="icon mb-3" />
              <h5 className="fw-bold mb-3">Scale & Expansion</h5>
              <ul className="custom-list1 text-start">
                <li>Diversified Regional reach from Day 1</li>
                <li>Seamlessly repeatable and scalable framework</li>
              </ul>
            </div>
          </div>

          {/* Growth & Liquidity */}
          <div className="col-md-4">
            <div className="solution-card p-4 h-100">
              <FaChartLine className="icon mb-3" />
              <h5 className="fw-bold mb-3">Growth & Liquidity</h5>
              <ul className="custom-list1 text-start">
                <li>High yield for lenders</li>
                <li>Fast access to capital for borrowers in 24 hours</li>
                <li>Competitiveness for platforms</li>
              </ul>
            </div>
          </div>

          {/* Value-added Services */}
          <div className="col-md-4">
            <div className="solution-card p-4 h-100">
              <FaHandshake className="icon mb-3" />
              <h5 className="fw-bold mb-3">Value-added Services</h5>
              <ul className="custom-list1 text-start">
                <li>Attraction and retention of platform participants</li>
                <li>Affordable access to business-critical solutions</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/*  platform-section*/}
     <section className="platform-section py-5 text-center text-white" data-aos="fade-up" >
      <div className="container">
        <h3 className="fw-bold mb-2">CXDA Platform Infrastructure</h3>
        <p className="mb-5 fs-4">
          A complete loan application management infrastructure for SMB/SME access to finance
        </p>

        <div className="row justify-content-center g-4">
          <div className="col-6 col-md-2">
            <div className="circle-icon mx-auto mb-3">
              <FaSearch />
            </div>
            <h6 className="fw-semibold">KYC &amp; Compliance</h6>
          </div>

          <div className="col-6 col-md-2">
            <div className="circle-icon mx-auto mb-3">
              <FaChartLine />
            </div>
            <h6 className="fw-semibold">Financial Analysis &amp;<br />Credit Scoring</h6>
          </div>

          <div className="col-6 col-md-2">
            <div className="circle-icon mx-auto mb-3">
              <FaFileAlt />
            </div>
            <h6 className="fw-semibold">Documentation</h6>
          </div>

          <div className="col-6 col-md-2">
            <div className="circle-icon mx-auto mb-3">
              <FaHandsHelping />
            </div>
            <h6 className="fw-semibold">Servicing</h6>
          </div>

          <div className="col-6 col-md-2">
            <div className="circle-icon mx-auto mb-3">
              <FaBriefcase />
            </div>
            <h6 className="fw-semibold">Portfolio<br />Management</h6>
          </div>
        </div>
      </div>
    </section>
    <SMEAssetsSection/>
      <Globalteam />
    <OmanTeam/>
    <ContactSection/>
    
    </div>
  )
}

export default Cxda